import moment from "moment";
import DateMomentUtil from "../../../../../../app/util/DateMomentUtil";
import InputValidationStateBo from "../../../../../../form/input/InputValidationStateBo";
import InputValidator from "../../../../../../form/input/InputValidator";
import InputValidatorI from "../../../../../../form/input/InputValidatorI";

export default class VnGeburtsdatumValidator implements InputValidatorI {

    private value?: string;

    constructor(newValue?: string) {
        this.value = newValue;
    }

    validate(): InputValidationStateBo {
        // *** is blank
        if (InputValidator.isBlank(this.value)) {
            return InputValidationStateBo.createInValid("Geben Sie bitte Ihr Geburtsdatum an.")
        }

        if (!InputValidator.isDate(this.value)) {
            return InputValidationStateBo.createInValid("Geben Sie bitte Ihr Geburtsdatum an. (TT.MM.JJJJ)")
        }

        if (this.value) {
            const gebMoment = DateMomentUtil.parseLocalDate(this.value);
            const datum18 = DateMomentUtil.addYears(gebMoment, 18);

            if (datum18.isAfter(moment())) {
                return InputValidationStateBo.createInValid("Sie müssen mindestens 18 Jahre alt sein.")
            }
        }

        // *** Wert is gueltig!
        return InputValidationStateBo.createValid();
    }

}